import useIsDesktop from "@hooks/useIsDesktop"

import { NavBottomBar } from "@organisms"
import NavSidebar from "@organisms/NavSidebar/NavSidebar"

import { AppFrame } from "@templates"

import styles from "./Menu.module.scss"

export default function Menu() {
    const isDesktop = useIsDesktop()

    return (
        <AppFrame.Root>
            {!isDesktop && (
                <>
                    <div className={styles.sidebar}>
                        <NavSidebar hideCreateButton={true} hideSearchButton={true} />
                    </div>
                    <NavBottomBar />
                </>
            )}
        </AppFrame.Root>
    )
}
